exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".webhook-selector .ant-select-selector {\n  max-height: 200px;\n  overflow-y: scroll;\n  margin-right: -8px;\n}\n", ""]);

// exports
